export const initReadmore = () => ({
  init() {
    const self = this;
    initListner(self);
  },

  ToggleAll(value) {
    const textcontainer = document.querySelector(
      '.list-more-container-' + value.toString(),
    );
    const jsReadMoreText = document.querySelector(
      '.js-show-more-' + value.toString(),
    );
    const jsReadLessText = document.querySelector(
      '.js-show-less-' + value.toString(),
    );
    const jsListMore = document.querySelector(
      '.js-list-more-' + value.toString(),
    );

    textcontainer.classList.toggle('hide');
    jsReadMoreText.classList.toggle('hide');
    jsReadLessText.classList.toggle('hide');
    jsListMore.classList.toggle('open');
  },
});

function initListner(self) {
  const buttons = document.querySelectorAll('.js-list-more');
  for (var i = 0; i < buttons.length; i++) {
    var selff = buttons[i];

    selff.addEventListener(
      'click',
      function() {
        self.ToggleAll(this.id);
      },
      false,
    );
  }
}
